import { render } from "./PagesPanel.vue?vue&type=template&id=cebfa260"
import script from "./PagesPanel.vue?vue&type=script&lang=js"
export * from "./PagesPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PagesPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cebfa260"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cebfa260', __exports__)) {
    api.reload('cebfa260', __exports__)
  }
  
  module.hot.accept("./PagesPanel.vue?vue&type=template&id=cebfa260", () => {
    api.rerender('cebfa260', render)
  })

}


export default __exports__